// Calendar dates as Norway sees them.
//
// `new Date().toISOString().slice(0, 10)` is the date in UTC, which in Norway is still
// yesterday until 01:00 (02:00 in summer). That put a tournament starting today under
// "Upcoming" for the first hour or two of its day, made a new tournament default to
// yesterday's date, and could show a subscription's trial end or withdrawal deadline a
// day earlier in the app than in the e-mail, which the server writes in Europe/Oslo.

const OSLO = 'Europe/Oslo';

/**
 * The date in Norway at instant `ms` (default: now), as 'YYYY-MM-DD'.
 * @param {number|Date} [ms]
 */
export function osloDate(ms = Date.now()) {
    const parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: OSLO, year: 'numeric', month: '2-digit', day: '2-digit'
    }).formatToParts(new Date(ms));
    const get = (type) => (parts.find(p => p.type === type) || {}).value || '';
    return `${get('year')}-${get('month')}-${get('day')}`;
}
